/**
 * Feature flags
 * Central place to toggle product behaviour without editing components.
 */

export const featuresConfig = {
    // Closed beta: when true, the "Start Free" buttons open the
    // "Currently in closed beta" modal instead of the signup flow.
    // Set to false to re-enable normal signup.
    closedBeta: true,
}

export default featuresConfig
